import {
  Component,
  inject,
  signal,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ButtonComponent, IconComponent, Table2Component } from '@pansa/ui';
import { GroupUserDTO } from '../../models/group.model';
import { SortEvent, SortState } from '@app/shared/models/sort.model';

@Component({
  selector: 'rqa-group-list-details',
  templateUrl: './group-list-details.component.html',
  styleUrl: './group-list-details.component.scss',
  imports: [CommonModule, IconComponent, Table2Component, ButtonComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class GroupListDetailsComponent {
  @Input() groupUsers: GroupUserDTO[] = [];
  @Input() groupId: string = '';
  @Output() deleteUser = new EventEmitter<{ groupId: string; username: string }>();
  private router = inject(Router);

  readonly sort = signal<SortState>({
    key: 'id',
    direction: ''
  });

  trackBy: keyof GroupUserDTO = 'username';

  onEditUser(username: string): void {
    this.router.navigate(['/users/edit', username]);
  }

  onDeleteUser(user: GroupUserDTO): void {
    this.deleteUser.emit({ groupId: this.groupId, username: user.username });
  }

  onSortChange(user: SortEvent<GroupUserDTO>): void {
    this.sort.set({
      key: user.key,
      direction: user.direction
    });
  }
}
